import {
  ComponentHeader,
  ComponentHeaderProps,
} from "design-system/components/primitives/component-header/component-header";
import "./timeline-tease.scss";

import cn from "clsx";

import {
  TimelineEvent,
  TimelineEventProps,
} from "design-system/components/primitives/timeline-event/timeline-event";
import { Alignment } from "design-system/types/types";
import { MouseEventHandler } from "react";

export interface TimelineTeaseProps {
  header?: ComponentHeaderProps;
  align?: Alignment;
  events: Array<TimelineEventProps>;
  onClick?: MouseEventHandler;
}

/**
 * ## See it in use on...
 * - A [detail page with timeline content](/story/example-pages-detail-pages-timeline--story)
 *
 * - **`id: CB-021-000-00`**
 * - **`data-region: cb__timeline-tease`**
 */
export function TimelineTease({
  header,
  align = "center",
  events,
}: TimelineTeaseProps) {
  const wrapperClass = cn(
    `hbs-global-align-${align}`,
    "hbs-timeline-tease-wrapper",
  );

  return (
    <section className={wrapperClass}>
      {header && <ComponentHeader {...header} />}
      <div className="hbs-timeline-events">
        {events.map((event, i) => (
          <TimelineEvent
            key={i}
            {...event}
            HeadingLevelStart={header ? "h3" : "h2"}
          />
        ))}
      </div>
    </section>
  );
}
